import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYDropdownInputRangeProps, IOYDropdownInputRangeState } from './const';
import { jeact } from '../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYDropdownInputRange extends OY<IOYDropdownInputRangeProps, IOYDropdownInputRangeState> {
  static displayName = 'OYDropdownInputRange';

  static defaultProps: Partial<IOYDropdownInputRangeProps> = {
    placeholder: '请输入',
    dropdownOffset: 0,
    info: [],
    valtype: 'any'
  }

  public state: IOYDropdownInputRangeState = {
    value: []
  };

  $node = {}

  preValue: string[] = [];

  inputRange: any;

  isCalc = false;

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  renderButton() {
    this.$el.find('oy-button').each((_index, element) => {
      const $element = $(element);
      const onClick = $element.hasClass('cancel') ? this._triggerBodyClick : this.handleConfirmClick;
      $element.OYButton({
        onClick: onClick.bind(this)
      })
    })
  }

  renderInputRange() {
    const { value, placeholder, valtype } = this.props;
    this.inputRange = this.$el.find('oy-input-range').OYInputRange({
      value,
      placeholder,
      valtype,
      onChange: (cvalue: string[]) => {
        this.state.value = cvalue;
      }
    })
  }

  setNode() {
  }

  bindElClick() {
    this.$el.click((ev: Event) => {
      ev.stopPropagation();
      this._triggerBodyClick();
    })

    this.$class(styles.dropdown).click((ev: Event) => {
      ev.stopPropagation();
    })
  }

  bindNameClick() {
    this.$class(styles.name).click((event: Event) => {
      if (!this.$el.hasClass(styles.active)) {
        setTimeout(() => {
          $(document.body).one('click', this.handleCancelClick.bind(this))
        });
        this.calcPosition();
        this.$el.addClass(styles.active)
      } else {
        this._triggerBodyClick();
      }
    })
  }

  private handleCancelClick() {
    this.$el.removeClass(styles.active)
  }

  private handleConfirmClick() {
    if (this.state.value.filter(va => va).length) {
      this.eventEmitter.emit(EEventType.onChange, this.state.value)
    }
    this._triggerBodyClick();
  }

  private _triggerBodyClick() {
    $(document.body).trigger('click')
  }

  private calcPosition() {
    if (!this.isCalc) {
      const { width } = this.$class(styles.name).get(0).getBoundingClientRect();
      const $dropDown = this.$class(styles.dropdown);
      $dropDown.css({
        left: -Math.floor(($dropDown.outerWidth() - width) / 2)
      })
      this.isCalc = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OYDropdownInputRange/index.ts